import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css";

createApp(App).use(router).use(VueAwesomeSwiper).mount("#app");
